import { useEffect, useState } from 'react';

import { ScreenSize, useGetScreenSize } from '../../hooks';
import { useUserContext } from '../../contexts';

export const useNumberOfPopularPrompts = (): number => {
    const { user } = useUserContext();
    const [numberOfPopularPrompts, setNumberOfPopularPrompts] = useState(0);

    const screenSize = useGetScreenSize();

    useEffect(() => {
        if (screenSize < ScreenSize.SmallDesktop) {
            setNumberOfPopularPrompts(0);

            return;
        }

        setNumberOfPopularPrompts((screenSize >= ScreenSize.Desktop ? 3 : 2) - Number(user.isAuth));
    }, [screenSize, user.isAuth]);

    return numberOfPopularPrompts;
};
